import { z } from 'zod';
/**
 * Public auth wire contracts used by both browser frontends. The actual
 * Cognito calls stay in each app because they need app-specific backend URLs
 * and session persistence, but the response parsing should not drift.
 */
export const AuthConfigSchema = z
    .object({
    authEnabled: z.literal(true),
    region: z.string(),
    userPoolId: z.string(),
    clientId: z.string(),
})
    .or(z.object({ authEnabled: z.literal(false) }));
export const CognitoAuthResponseSchema = z.object({
    ChallengeName: z.string().optional(),
    Session: z.string().optional(),
    AuthenticationResult: z
        .object({
        AccessToken: z.string().optional(),
        IdToken: z.string().optional(),
        RefreshToken: z.string().optional(),
        ExpiresIn: z.number().optional(),
    })
        .optional(),
});
//# sourceMappingURL=auth.js.map